import DataModel from '../../common/model/DataModel';

export default class OptableSummaryDataModel extends DataModel {
  constructor(preferenceGroupName) {
    super();

    this.preferenceGroupName = preferenceGroupName;

    this.contracts = [];
    this.isOptingLimitExceeded = false;
  }
}